import { css } from '@emotion/react';

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
